import * as ActionTypes from '../ActionTypes';

// Module
export const GetATSModuleAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_MODULE_GET_REQUEST,
        params,
        callback
    }
}